import { ThunkType } from "../../../../../core/store/reducers";
import { setData } from "../businessActivitiesDataSlice";
import getBusinesActivitiesDataApi from "../api/getBusinessActivitiesData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.reports.exchbusiness.businessActivities;

  const pagedTrades = await dispatch(getBusinesActivitiesDataApi(user, filter));

  dispatch(setData(pagedTrades || []));
};
